module.exports = __webpack_public_path__ + "static/settings_menu-cd380aae18dc8baee602cd0ca5d8515a.png";